export default {
  validation: "Este campo es obligatorio",
};
